import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import LabeledDropdown from './LabeledDropdown';
import { NumberFormatter } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

class PersonalizationOption extends React.Component {
  constructor() {
    super(...arguments);

    this.handleChange = this.handleChange.bind(this);
  }

  renderOptionValues() {
    const translate = this.context.translate || (() => {});
    var optionValues = this.props.option_values || [];
    var output = [];

    output.push(
      <option value='select'>
        {translate('products.option_select')}
      </option>
    );
    optionValues.forEach(function (ov) {
      let optionText = ov.name;
      const increaseBy = +ov.increase_by;
      if (increaseBy) {
        optionText = translate('products.option_name_price_increase', {
          option_name: ov.name,
          price_increase: NumberFormatter.toFormattedCurrency(increaseBy)
        });
      }
      output.push(
        <option key={ 'personalization-option-' + ov.id } value={ ov.id }>
          {optionText}
        </option>
      );
    });

    return output;
  }

  handleChange(e) {
    const id = this.props.id;
    const val = e.target.value;
    const enabled =
      this.props.required || (val !== '' && val !== null && val !== 'select');
    this.props.onChange(id, enabled, val);
  }

  render() {
    const fieldId = 'personalization-select-' + this.props.id;
    const translate = this.context.translate || (() => {});
    const { Form } = UX2.Group;

    let labelText = this.props.name;
    if (!this.props.required) {
      labelText = translate('products.optional_label_text', {
        name: labelText
      });
    }

    return (
      <Form.Group style={{ marginBottom: 'medium' }}>
        <LabeledDropdown
          labelText={ labelText }
          labelColor={ this.props.labelColor }
          id={ fieldId }
          onChange={ this.handleChange }
          children={ this.renderOptionValues() }
        />
      </Form.Group>
    );
  }
}

PersonalizationOption.propTypes = {
  onChange: PropTypes.func,
  labelColor: PropTypes.string,
  option_values: PropTypes.array,
  required: PropTypes.bool,
  id: PropTypes.any,
  name: PropTypes.any
};

PersonalizationOption.defaultProps = {
  labelColor: 'lowContrast',
  onChange: function () {}
};

PersonalizationOption.contextTypes = {
  translate: PropTypes.func
};

export default PersonalizationOption;
